import { useMutation, useQueryClient } from 'react-query';
import { useCurrentUserCtx } from 'client/contexts/CurrentUser';
import { FETCH_EPISODE_OVERVIEW } from 'client/hooks/episodes/useFetchEpisodeOverview';
import { AnchorAPI } from '../../modules/AnchorAPI';

function useSaveAudioToEpisode() {
  const queryClient = useQueryClient();
  const {
    state: { webStationId },
  } = useCurrentUserCtx();
  const { mutate, status } = useMutation(
    ({
      webEpisodeId,
      audioId,
      audioIds,
    }: {
      webEpisodeId: string;
      audioId?: string;
      audioIds?: string[];
    }) => {
      if (!webStationId) {
        return Promise.reject(
          new Error('webStationId is required to add audio to episode')
        );
      }
      return AnchorAPI.saveAudioToEpisode({
        stationId: webStationId!,
        episodeId: webEpisodeId,
        audioId,
        audioIds,
      });
    },
    {
      onSuccess: (_data, variables) => {
        const { webEpisodeId } = variables;
        return queryClient.invalidateQueries([
          FETCH_EPISODE_OVERVIEW,
          webEpisodeId,
        ]);
      },
    }
  );

  return { saveAudioToEpisode: mutate, status };
}

export { useSaveAudioToEpisode };
